//DagiInfoForPunkt
import { Class } from "../../utils";
import SqDetailsHandler from "../../details/SqDetailsHandler";
export default Class(SqDetailsHandler, {
  initialize: function initialize(options) {
    var isMore = false;

    if (typeof options !== 'undefined') {
      if (typeof options.more !== 'undefined') isMore = options.more;
    } else {
      throw 'DagiInfoForPunkt: GeoSearcher ikke angivet';
    }

    var myOptions = {
      buttonText: "DAGI-info",
      distanceFilter: 'zero',
      isApplicable: function isApplicable(result) {
        return result.geometry !== null && result.geometry.type === 'Point';
      },
      more: isMore,
      searchers: [options.geoSearcher]
    };
    SqDetailsHandler.prototype.initialize.apply(this, [myOptions]);
  },
  CLASS_NAME: 'Septima.Search.DagiInfoForPunkt'
});